<template>
  <modal id="second-step-verification">
    <div class="boxVerification">
      <div class="" id="bp-left">
        <div class="partition" id="partition-verification">
          <div class="partition-title">2-Step verification</div>

          <div class="col-md-12" style="text-align: center">
            <img src="/favicon/c3-logo.png" />
          </div>
          <div class="partition-form">
            <form autocomplete="false">
              <div class="col-md-11 form-container">
                <div class="col-md-12" style="text-align: left">
                  <h3>Enter the token we just sent you via email</h3>
                </div>
                <div class="col-md-12">
                  <input
                    class="form-control"
                    v-model="verificationData.token"
                    type="password"
                    autocomplete="off"
                    required
                    placeholder="Enter token (6-digit)"
                    :maxlength="6"
                  />
                </div>
                <div class="col-md-12">
                  <button
                    type="submit"
                    class="mb-4 col-md-12 btn updatePasswordBtn"
                    @click.prevent="verifytoken"
                    :disabled="inValidInputs"
                  >
                    <span
                      ><i class="mr-2 fas fa-check-circle fa-fw"></i
                      >Verify</span
                    >
                  </button>
                </div>
                <a href="#" @click.prevent="closeModal">Start Over</a>
                <div class="mt-4">
                  Need help? Contact
                  <a href="mailto:support@communitycareconnection.com"
                    >Our Support</a
                  >
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </modal>
</template>
<script>
import { mapState, mapActions } from "vuex";
import Swal from "sweetalert2";
import Auth from "@/auth.js";

export default {
  name: "TwoStepVerificationModal",
  props: ["user"],
  data() {
    return {
      verificationData: {
        token: "",
      },
    };
  },
  computed: {
    ...mapState(["auth"]),
    inValidInputs() {
      return this.verificationData.token.length != 6;
    },
  },
  methods: {
    ...mapActions({
      doVerification: "auth/secondStepVerification",
      doLogout: "auth/logout",
      getVendors: "vendors/getSignedInVendors",
    }),
    verifytoken: function () {
      let vm = this;
      this.doVerification({ token: this.verificationData.token })
        .then(function (res) {
          if (res) {
            Auth.verify.set(true);
            vm.$store.dispatch("hideModal", "second-step-verification");
            if (vm.auth.iframeSrc == "crm") {
              window.location.href = `/orders?src=${vm.auth.iframeSrc}&keeplogin=true`;
            } else {
              if ((vm.user || {}).isVendor) {
                vm.getVendors({
                  accessToken: vm.auth.token,
                }).then(function (vendors) {
                  if (vendors && vendors.length) {
                    window.location.href = `/vendors/${vendors[0].id}?login=${vendors.length}`;
                  }
                });
              } else {
                window.location.href = "/";
              }
            }
          }
        })
        .catch(function () {
          Swal.fire({
            type: "error",
            title: "Invalid Verification Token",
          });
        });
    },
    closeModal: function () {
      this.doLogout({ noRedirect: true }).then(() => {
        this.$store.dispatch("hideModal", "second-step-verification");
      });
    },
  },
};
</script>
<style lang="scss">
#second-step-verification {
  .modal-header,
  .modal-footer {
    display: none;
  }
  .modal-content {
    max-width: 445px;
    margin: 0 auto;
    margin-top: 10%;
  }
}
.partition-form {
  margin-top: 20px;
}
.boxVerification {
  width: 100%;
  max-width: 400px;
  min-height: 500px;
  color: #254b7b;
  font-size: 12px;
  margin: 0 auto;
  a {
    color: #03a9f4;
    font-size: 15px;
  }
  .form-container {
    text-align: center;
    margin: 0 auto;
  }
  .updatePasswordBtn {
    background-color: #2c7be5;
    border-radius: 4px;
    box-sizing: border-box;
    padding: 10px;
    letter-spacing: 1px;
    font-family: "Open Sans", sans-serif;
    font-weight: 400;
    margin-top: 8px;
    color: white;
    cursor: pointer;
    border: 1px solid #d2ddec;
    text-transform: uppercase;
    transition: 0.1s all;
    font-size: 10px;
    margin-top: 15px;
    &:hover,
    &:active,
    &:focus {
      border-color: #2c7be5;
      background-color: white;
      color: #2c7be5;
    }
    &:disabled {
      pointer-events: none;
    }
  }
  input[type="checkbox"] {
    transform: scale(1.2);
  }
  .partition {
    width: 100%;
    height: 100%;
    .partition-title {
      box-sizing: border-box;
      padding: 30px;
      padding-top: 10px;
      padding-bottom: 0px;
      width: 100%;
      text-align: center;
      letter-spacing: 1px;
      font-size: 30px;
      font-weight: 300;
    }
  }
  .large-btn {
    background: white;
    span {
      font-weight: 600;
    }
    &:hover {
      color: white !important;
    }
  }
}

.checkboxLabel {
  font-size: 17px;
  line-height: 17px;
  position: relative;
  bottom: 1px;
}
</style>
